import React from 'react';
import PropTypes from 'prop-types';
import { Bastes } from './';

import { NANDINOS_BASTES } from '../modules/constants';

function Nandinos({ modifiers, bastes, hideCalories, toggle }) {
    if (!modifiers.length || !bastes) {
        return null;
    }

    const baste = modifiers.find((item) => item.slug === 'choose-baste');

    return (
        <>
            {baste && (
                <Bastes
                    toggle={toggle}
                    baste={baste.options}
                    bastes={bastes}
                    title={NANDINOS_BASTES}
                    hideCalories={hideCalories}
                />
            )}
        </>
    );
}

Nandinos.propTypes = {
    modifiers: PropTypes.array,
    bastes: PropTypes.array,
    hideCalories: PropTypes.bool,
    toggle: PropTypes.func
};

export { Nandinos };
